import { gql } from '@apollo/client';

import { ListDealMessages } from './__generated__/fragments';

// Shared by every consumer of this query's `dealMessages.entities` selection -- centralized here,
// next to the query that produces it, instead of each consumer re-deriving an identical alias.
export type ListDealMessages_dealMessages_entities = NonNullable<
  NonNullable<NonNullable<ListDealMessages>['dealMessages']>['entities']
>[number];

export const ADD_DEAL_MESSAGE = gql`
  mutation AddDealMessage($input: CreateDealMessageInput!) {
    addDealMessage(input: $input) {
      message
      id
    }
  }
`;

export const LIST_DEAL_MESSAGES = gql`
  query ListDealMessages($deal_id: ID!, $pagination: DealMessagePaginationInput) {
    dealMessages(deal_id: $deal_id, pagination: $pagination) {
      entities {
        id
        message
        created_time
        author {
          given_name
          family_name
          is_current_user
        }
      }
      last_evaluated_key {
        id
        deal_id
        created_time
      }
    }
  }
`;
